import React from 'react'
import { StyleProp, View, ViewStyle } from 'react-native'

interface Props {
  containerStyle?: StyleProp<ViewStyle>
  children?: React.ReactNode
}

const List = ({ containerStyle, children }: Props) => <View style={containerStyle}>{children}</View>

export default List
